import {
    responsiveFontSizes,
    StyledEngineProvider,
    ThemeProvider,
    unstable_createMuiStrictModeTheme,
} from '@mui/material';
import { PropsWithChildren } from 'react';

// declare module '@mui/styles/defaultTheme' {
//   // eslint-disable-next-line @typescript-eslint/no-empty-interface
//   interface DefaultTheme extends Theme {}
// }

export function ProvideTheme({ children }: PropsWithChildren<{}>) {
    const theme = responsiveFontSizes(
        unstable_createMuiStrictModeTheme({
            palette: {
                primary: {
                    main: '#EF6C00',
                },
                secondary: {
                    main: '#15264C',
                },
                background: {
                    default: '#15264C', //'#3C3A36',
                },
            },
            components: {
                MuiFab: {
                    styleOverrides: {
                        root: {
                            '&.Mui-disabled': {
                                color: '#0d0d0d',
                                backgroundColor: '#4fc3f7',
                            },
                        },
                    },
                },
            },
        })
    );
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </StyledEngineProvider>
    );
}
